import { Link } from 'react-router-dom';
import { companyInfo } from '@/mocks/navigation';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20collaborative%20workspace%20with%20diverse%20team%20working%20together%20on%20digital%20documents%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20geometric%20abstract%20shapes%2C%20soft%20gradient%20background%2C%20minimal%20professional%20aesthetic%2C%20clean%20composition%20with%20negative%20space&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50/90 text-sm mb-8">
          <i className="ri-sparkling-2-line"></i>
          <span>已服务 10,000+ 企业团队</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          {companyInfo.slogan}
        </h1>
        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          一起草是专为团队协作打造的在线草稿编辑平台，支持多人实时共同起草文件、合同、方案与创意内容。告别反复传文件的烦恼，让团队协作起草更高效、更顺畅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/#"
            className="w-full sm:w-auto text-center whitespace-nowrap px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 text-base no-underline"
          >
            免费开始使用
          </Link>
          <Link
            to="/#features"
            className="w-full sm:w-auto text-center whitespace-nowrap px-8 py-3.5 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-all duration-200 text-base no-underline"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <a href="#features" className="text-background-50/50 hover:text-background-50 transition-colors duration-200 cursor-pointer">
          <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}